import moment from 'moment'
import { type DeliveryHours } from 'domains/shifts/components/types'
import { timeZoneOffset } from 'legacy/common/dateUtils'
import { type WarehouseEarlyPickingHour } from 'domains/shifts/components/utils/fetchEarlyHoursForWarehouse'

interface Props {
  deliveryHours: DeliveryHours
  warehouseEarlyHours?: WarehouseEarlyPickingHour
}

export const calculateRegularShiftHours = ({
  deliveryHours,
  warehouseEarlyHours,
}: Props): DeliveryHours => {
  let startTime = deliveryHours.start

  if (warehouseEarlyHours && warehouseEarlyHours.earlyHour) {
    const parsedTimezone = timeZoneOffset(startTime)

    startTime = moment(startTime)
      .hours(warehouseEarlyHours.earlyHour)
      .utcOffset(parsedTimezone, true)
      .format()
  }

  return {
    ...deliveryHours,
    start: startTime,
  }
}
